import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';


import { FacturacionElectronicaConsultarPdfComponent} from './FacturacionElectronicaConsultarPdf.component';

import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';


const routes = [
    {
        path     : 'DescargarImagenDocumento',
        component: FacturacionElectronicaConsultarPdfComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'DescargarImagenDocumento'
        } 
    }
];

@NgModule({
    declarations: [
        FacturacionElectronicaConsultarPdfComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        FacturacionElectronicaConsultarPdfComponent
    ],
    bootstrap: [FacturacionElectronicaConsultarPdfComponent]
})

export class FacturacionElectronicaConsultarPdfModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/FacturacionElectronicaDescargarImagen/FacturacionElectronicaConsultarPdf.module.ts